import React, { forwardRef } from 'react'
import { makeStyles } from '@mui/styles'

import ClientConfig from '@/modules/client/config'
import { DocumentExportFormDatev } from '@/modules/document-export/forms'

const { clientDetail: { jumpMarkLinks } } = ClientConfig

const ClientDatevExportWidget = forwardRef(({ client }, ref) => {
  const classes = useStyes()

  return (
    <div id={jumpMarkLinks.taxAccountantExport} className={classes.root} ref={ref}>
      <DocumentExportFormDatev.box client={client} />
    </div>
  )
})

const useStyes = makeStyles(theme => ({
  root: {
    padding: 30,
    border: theme.border,
    borderRadius: theme.borderRadius,
    backgroundColor: theme.white,
    width: '100%',
  },
}))

export default ClientDatevExportWidget
